// app/javascript/controllers/smart_schedule_confirmation_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "startDate",
    "initialStartDate",
    "checkbox",
    "submitButton",
    "alert"
  ]

  connect() {
    this.update() // initialize button state on page load
  }

  update() {
    const today = new Date()

    // Read values
    const startDateValue = this.startDateTarget.value
    const initialStartDateValue = this.initialStartDateTarget.value

    const startDate = startDateValue ? new Date(startDateValue) : null
    const initialStartDate = initialStartDateValue ? new Date(initialStartDateValue) : null

    // Determine if change affects history
    const affectsHistory =
      (startDate && startDate < today) ||
      (initialStartDate && initialStartDate < today)

    // Show/hide alert
    if (affectsHistory) {
      this.alertTarget.classList.remove("d-none")

      // Force checkbox unchecked the first time alert appears
      if (!this.alertTarget.dataset.shown) {
        this.checkboxTarget.checked = false
        this.alertTarget.dataset.shown = "true"
      }
    } else {
      this.alertTarget.classList.add("d-none")
      delete this.alertTarget.dataset.shown
    }

    // Enable/disable submit button
    const checkboxChecked = this.checkboxTarget.checked
    this.submitButtonTarget.disabled = affectsHistory && !checkboxChecked
  }
}
